import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router';

class Shop extends React.Component {
   render() {
      return (
         <div className="Shop" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/shop/" activeStyle={{ color: 'red' }} >Shop</Link>
                  </Navbar.Brand>
               </Navbar.Header>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

Shop.propTypes = {
   children: PropTypes.object
};

export default Shop;



/** WEBPACK FOOTER **
 ** ./src/components/ShopManagement/Shop/Shop.js
 **/